import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);

// VERY SIMPLE ROUTING LOGIC FOR TENANTS
const hostname = window.location.hostname;
const lowerHostname = hostname.toLowerCase();
const hasClientPortalQuery = (() => {
  try { return new URLSearchParams(window.location.search).get('clientportal') === 'true'; }
  catch { return false; }
})();

// Determine if we are on the main Werftools app
const isMainApp =
  lowerHostname === 'localhost' ||
  lowerHostname === '127.0.0.1' ||
  // Any *.localhost host (e.g. clientportal.localhost) is also the local dev app,
  // so we don't accidentally treat it as a tenant career site.
  lowerHostname.endsWith('.localhost') ||
  hasClientPortalQuery ||
  lowerHostname === 'werftools.nl' ||
  lowerHostname.startsWith('www.werftools.nl') ||
  lowerHostname.startsWith('app.werftools.nl') ||
  lowerHostname.startsWith('development.werftools.nl') ||
  lowerHostname.startsWith('clientportal.werftools.nl') ||
  lowerHostname.startsWith('tool.werftools.nl');

if (!isMainApp) {
  // Lazy-load tenant shell only on vanity/custom domains — avoids pulling this graph
  // (and /services/supabaseService) on every main-app page (e.g. /app/candidate-engagement).
  void import('./src/components/TenantCareerSite')
    .then(({ default: TenantCareerSite }) => {
      root.render(<TenantCareerSite hostname={hostname} />);
    })
    .catch((err) => {
      console.error('[bootstrap] Tenant career site failed to load', err);
      root.render(
        <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6 text-center font-sans text-slate-700">
          <p className="text-sm font-medium">Career site kon niet worden geladen. Vernieuw de pagina of probeer later opnieuw.</p>
        </div>
      );
    });
} else {
  root.render(<App />);
}
